import { useRootStore } from '../hooks/useRootStore';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Link, Skeleton, useMediaQuery } from '@mui/material';
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import './ActiveIssue.css';
import type { Issue } from '../data/Issue';
import moment, { Duration } from 'moment';
import TrackingToggler from './TrackingToggler';
import { UserType } from '../data/UserType';
import { EmployeeProfile } from '../data/UserProfile';

const ActiveIssue = observer(() => {

    const { api } = useRootStore();
    const { userProfile, activityStartTime, activityStarted } = useRootStore();

    const [issue, setIssue] = useState<Issue | null | undefined>(undefined);
    const [runningTime, setRunningTime] = useState<Duration | null>(null);

    const mobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    useEffect(() => {
        let timerID: NodeJS.Timeout;

        if ((userProfile?.UserType === UserType.Employee) && (userProfile as EmployeeProfile).ActiveIssueId) {
            api.getIssue((userProfile as EmployeeProfile).ActiveIssueId!)
                .then(issue => setIssue(issue));

            if (activityStarted) {
                timerID = setInterval(() => setRunningTime(moment.duration(moment().diff(moment(activityStartTime)))), 1000);
            }
        } else {
            setIssue(null);
        }

        return () => {
            if (timerID) {
                clearInterval(timerID);
            }
        };

    }, [userProfile, api, activityStarted, activityStartTime]);

    return (
        userProfile?.UserType != UserType.Employee ? '' :            
            <Box className={"active-issue" + (issue ? " yes" : " no")}>
                {issue === undefined ? <Skeleton animation="wave" sx={{ height: '100%', flex: 1, ml:1, mr:1}} /> :
                    issue ?
                        <>
                            <Box className="active-issue-link" sx={{ display:'flex' }}>
                                <Box sx={{ mr: 1 }}>Активная задача:</Box>
                                <Link href={`/issues/${issue?.ID}`} title="К задаче"><b>{issue?.Subject}</b></Link>
                            </Box>
                            <Box className="active-issue-activity" sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box sx={{mr:1}}>
                                    {
                                        activityStarted
                                            ? 'Активность начата: ' + moment(activityStartTime).format('DD.MM.YYYY HH:mm') + ' (' + (runningTime ? runningTime.format('hh:mm:ss', { trim: false }) : '00:00:00') + ')'
                                            : issue?.LastActivity
                                                ? `Последняя активность: ${moment(issue.LastActivity.DateStart).format('DD.MM.YYYY HH:mm')} (${moment.duration(issue.LastActivity.Hours * 60 * 60 * 1000).format("hh:mm:ss", { trim: false })})`
                                                : 'Нет активности по задаче'
                                    }
                                </Box>
                                <TrackingToggler id={issue.ID} size={mobile ? 28 : 18} stopColor="red" playColor="white" />
                            </Box>
                        </>
                        : <Box>Нет активной задачи</Box>
                }
            </Box>
    );
})

export default ActiveIssue;